'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

var _uikit = require('../lib/uikit');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Element = function Element(props) {
  var cssClassNames = _uikit.helpers.cleanClasses([props.classes, props.className]);

  var cleanProps = _uikit.helpers.cleanProps([])(props);

  return _react2.default.createElement(
    'div',
    _extends({
      className: cssClassNames
    }, cleanProps),
    props.children
  );
};

Element.propTypes = {
  classes: _react2.default.PropTypes.array,
  className: _react2.default.PropTypes.string,
  children: _react2.default.PropTypes.any
};

function createElement() {
  return (0, _base2.default)(Element);
}
exports.default = createElement;


//////////////////
// WEBPACK FOOTER
// ./~/react-uikit-base/lib/element.js
// module id = 876
// module chunks = 0